type CsPublishDetails = {
    environment: string;
    locale: string;
    time: string;
    user: string;
};

export type ContentStackItemData = {
    _in_progress: boolean
    _version: number
    locale: string
    uid: string
    updated_at: string // ISO
    updated_by: string // User's ID
    title: string
    publish_details: CsPublishDetails
} & Record<string, unknown>;

export interface ContentStackItem<T = ContentStackItemData> {
    content_type_uid: string;
    type: string; // entry_published etc
    event_at: string;
    data: T
}

export interface ContentStackRawAsset extends Partial<ContentStackItemData> {
    url: string
    updated_at: string
    filename: string
    dimension?: {
        width: number
        height: number
    }
    content_type: string
}

export enum CsAssetSize {
    QTR_100VW = 'QTR_100VW',
    THIRD_100VW = 'THIRD_100VW',
    HALF_100VW = 'HALF_100VW',
    FULL_100VW = 'FULL_100VW',
    QTR_MAX_WIDTH = 'QTR_MAX_WIDTH',
    THIRD_MAX_WIDTH = 'THIRD_MAX_WIDTH',
    HALF_MAX_WIDTH = 'HALF_MAX_WIDTH',
    FULL_MAX_WIDTH = 'FULL_MAX_WIDTH',
}
export interface ContentStackRawAssetWithColor extends ContentStackRawAsset {
    color?: string|null
}
